import {
  FilterFieldConfig,
  FilterRule,
} from '../../view-model/InfluencerList.filterTypes';
import { toFilterDisplayText } from '../../view-model/InfluencerList.viewModel.mappers';
import { FilterChip } from './FilterChip';
import { AddFilterButton } from './AddFilterButton';
import * as styles from './FilterBar.css';

type FilterBarProps = {
  filterRules: FilterRule[];
  filterFieldConfigs: FilterFieldConfig[];
  onAddRule: (rule: FilterRule) => void;
  onRemoveRule: (ruleId: string) => void;
  onClearAll: () => void;
};

export const FilterBar = ({
  filterRules,
  filterFieldConfigs,
  onAddRule,
  onRemoveRule,
  onClearAll,
}: FilterBarProps) => (
  <div className={styles.filterBar}>
    {filterRules.map((rule) => (
      <FilterChip
        key={rule.id}
        displayText={toFilterDisplayText(rule)}
        onRemove={() => onRemoveRule(rule.id)}
      />
    ))}
    <AddFilterButton fieldConfigs={filterFieldConfigs} onAdd={onAddRule} />
    {filterRules.length > 0 ? (
      <button
        type="button"
        className={styles.clearAllButton}
        onClick={onClearAll}
      >
        Clear all
      </button>
    ) : null}
  </div>
);
